import { useMutation } from '@common/hooks';
import { Form, Select } from 'antd';
import { Store } from 'antd/lib/form/interface';
import React from 'react';
import { Modal } from '@common/components';
import { createMessage } from 'works/legacy/lib/message-helper';
import {
  DisputeExportArgs,
  DisputeExportMutation,
  DisputeExportResponse,
} from '@pay-bill/graphql';

const FILE_TYPE_OPTIONS = [
  { value: 'csv', label: 'Comma-separated Values (.csv)' },
  { value: 'xlsx', label: 'Microsoft Excel (.xlsx)' },
  { value: 'tsv', label: 'Tab-separated Values (.tsv)' },
];

export const DisputesExportModal = ({
  visible,
  onAction,
  id,
  entityType,
  disputeIds,
}: {
  visible: boolean;
  onAction: () => void;
  id: string;
  entityType: 'invoice' | 'reverse_invoice';
  disputeIds?: string[];
}) => {
  const [form] = Form.useForm();

  const [performExport, { loading }] = useMutation<
    DisputeExportResponse,
    DisputeExportArgs
  >(DisputeExportMutation, {
    onCompleted: (response) => {
      const { downloadUrl } = response.result.file;
      if (downloadUrl) {
        window.location.href = downloadUrl;
      }

      createMessage('success', `Disputes downloaded.`);
      onAction();
    },
    onError: () => {
      createMessage('error', 'Download failed. Please try again.');
    },
  });

  const exportFile = (values: Store) => {
    performExport({
      variables: {
        input: {
          entityId: id,
          entityType,
          format: values.fileType,
          disputeIds,
        },
      },
    });
  };

  return (
    <Modal
      visible={visible}
      cancelText="Cancel"
      okText="Download"
      onCancel={onAction}
      title="Disputes"
      confirmLoading={loading}
      onOk={form.submit}
      afterClose={() => form.resetFields()}
    >
      <Form layout="vertical" form={form} onFinish={exportFile}>
        <Form.Item
          name="fileType"
          label="File Type"
          rules={[{ required: true, message: 'Please select the file type' }]}
        >
          <Select
            placeholder="Select one"
            size="large"
            options={FILE_TYPE_OPTIONS}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
